import React from "react";
import { Edit } from "react-admin";
import { EditActions } from "../../common/form/FormActions";
import { SubscriptionForm } from "./SubscriptionForm";
import { useNotification } from "../../../common/hooks/useNotification";

interface ISubscriptionCreateProps {}

export const SubscriptionEdit = (props: ISubscriptionCreateProps) => {
  const notify = useNotification(props, "editSuccess");
  return (
    <Edit
      {...props}
      actions={<EditActions />}
      onSuccess={notify}
      title="resources.master-subscriptions.title.edit">
      <SubscriptionForm />
    </Edit>
  );
};
